import React, { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import { AgGridReact } from 'ag-grid-react'; // the AG Grid React Component
import { useNavigate } from "react-router-dom/dist";

import "./DeviceManagement.scss";
import "./NewDevice";
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import DeviceServices from "../../services/api/DeviceServices";
import NewDevice from './NewDevice';
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useDeviceContext } from "../../dataproviders/DeviceDataProvider";
import { useAuthContext } from '../../dataproviders/AuthDataProvider';

function DeviceManagement() {
    const mainContext = useMainContext();
    const authContext = useAuthContext();
    const deviceContext = useDeviceContext();
    const navigate = useNavigate();
    const gridRef = useRef(); // Optional - for accessing Grid's API
    const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
    const [containerHeight, setContainerHeight] = useState(0); // Initialize containerHeight
    const [isMobileScreen, setIsMobileScreen] = useState(false); // Initialize the mobile screen state
    //const [errors, setErrors] = useState([]);
    //const [password, setPassword] = useState("default");
    //const [invalidPasswordError, setInvalidPasswordError] = useState(false);
    
    class DeviceManagementCellRenderer {
        init(params) {
            this.params = params;
            this.eGui = this.createContextMenu();
        }

        createContextMenu() {
            const contextMenu = document.createElement('div');
            contextMenu.classList.add('context-menu');
            contextMenu.classList.add('dropdown');
            contextMenu.classList.add('dropdown-devicemgmt');

            const toggleBtn = document.createElement('button');
            toggleBtn.classList.add('dropdown-toggle');
            toggleBtn.setAttribute('type', 'button');
            toggleBtn.innerHTML = '<i class="fa-solid fa-ellipsis-vertical"></i>';
            toggleBtn.addEventListener('click', this.toggleHandler);

            const dropdownMenu = document.createElement('div');
            dropdownMenu.classList.add('dropdown-menu');

            // reset password
            const editDeviceBtn = document.createElement('button');
            editDeviceBtn.classList.add('dropdown-item');
            editDeviceBtn.innerHTML = '<i class="fa-light fa-pencil"></i> Edit Device';
            this.editDeviceHandler = this.editDeviceHandler.bind(this);
            editDeviceBtn.addEventListener('click', this.editDeviceHandler);

            // activate/deactivate device
            const toggleStatusBtn = document.createElement('button');
            toggleStatusBtn.classList.add('dropdown-item');

            if (this.params.data.status === 1) {
                toggleStatusBtn.innerHTML = '<i class="fa-regular fa-display-slash fa-sm"></i> Disable Device';
                this.deactivateStatusHandler = this.deactivateStatusHandler.bind(this);
                toggleStatusBtn.addEventListener('click', this.deactivateStatusHandler);
            }
            else {
                toggleStatusBtn.innerHTML = '<i class="fa-regular fa-display fa-sm"></i> Enable Device';
                this.activateStatusHandler = this.activateStatusHandler.bind(this);
                toggleStatusBtn.addEventListener('click', this.activateStatusHandler);
            }

            // delete device
            const deleteDeviceBtn = document.createElement('button');
            deleteDeviceBtn.classList.add('dropdown-item');
            deleteDeviceBtn.classList.add('dropdown-item-top-border');
            deleteDeviceBtn.innerHTML = '<i class="fa-regular fa-trash-can"></i> Delete';
            this.deleteDeviceHandler = this.deleteDeviceHandler.bind(this);
            deleteDeviceBtn.addEventListener('click', this.deleteDeviceHandler);

            // add buttons to dropdown menu
            dropdownMenu.appendChild(editDeviceBtn);
            dropdownMenu.appendChild(toggleStatusBtn);
            dropdownMenu.appendChild(deleteDeviceBtn);

            contextMenu.appendChild(toggleBtn);
            contextMenu.appendChild(dropdownMenu);
            return contextMenu;
        }

        getGui() {
            return this.eGui;
        }

        toggleHandler(e) {
            let el = e.target.closest('.dropdown-devicemgmt').querySelector('.dropdown-menu');

            // Check if the element has the .show class
            if (el.classList.contains('show')) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
            }
            else {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                const dropdownMenu = el;
                dropdownMenu.classList.toggle('show');

                e.target.closest('.dropdown-devicemgmt').classList.toggle('col-rps-light');
            }

            const container = document.querySelector('.device-management-container');
            const targetElement = container.querySelector('.dropdown-menu.show');

            if (targetElement) {
                const containerScrollHeight = container.scrollHeight;
                const containerRect = container.getBoundingClientRect();
                const targetElementRect = targetElement.getBoundingClientRect();

                const targetTop = targetElementRect.top - containerRect.top + container.scrollTop;
                const targetHeight = targetElementRect.height;

                if (targetTop + targetHeight > containerScrollHeight) {
                    targetElement.style.top = (-targetHeight) + 'px';
                }
            }

        }

        editDeviceHandler(e) {
            mainContext.UpdateDeviceState({ 
                showDeviceDetail: true, 
                deviceMode:'edit', 
                deviceData: {
                    deviceid: this.params.data.deviceid,
                    devicename: this.params.data.devicename,
                    deviceurl: this.params.data.deviceurl,
                    vesselid: this.params.data.vesselid,
                    vesselname: this.params.data.vesselname,
                }
            });
        }

        activateStatusHandler(e) {
            const container = document.querySelector('.dialog-overlay-activate');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                container.classList.remove('hide');

                const deviceNames = document.querySelectorAll('.device-name-section');
                deviceNames.forEach((deviceName) => {
                    deviceName.innerHTML = this.params.data.devicename;
                });

                const btn = document.querySelector('.btn-device-activate');
                btn.setAttribute('deviceid', this.params.data.deviceid);
                btn.setAttribute('devicename', this.params.data.devicename);
            }
        }

        deactivateStatusHandler(e) {
            const container = document.querySelector('.dialog-overlay-deactivate');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });
                container.classList.remove('hide');

                const deviceNames = document.querySelectorAll('.device-name-section');
                deviceNames.forEach((deviceName) => {
                    deviceName.innerHTML = this.params.data.devicename;
                });

                const btn = document.querySelector('.btn-device-deactivate');
                btn.setAttribute('deviceid', this.params.data.deviceid);
                btn.setAttribute('devicename', this.params.data.devicename);
            }
        }

        deleteDeviceHandler(e) {
            const container = document.querySelector('.dialog-overlay-delete');

            if (container) {
                //hide all dropdown-menu with .show
                const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
                dropdownMenus.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('show');
                });

                //hide all dropdown-menu with .show
                const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
                dropdownMenusMgmt.forEach((dropdownMenu) => {
                    dropdownMenu.classList.remove('col-rps-light');
                });

                container.classList.remove('hide');

                const deviceNames = document.querySelectorAll('.device-name-section');
                deviceNames.forEach((deviceName) => {
                    deviceName.innerHTML = this.params.data.devicename;
                });

                const btn = document.querySelector('.btn-device-delete');
                btn.setAttribute('deviceid', this.params.data.deviceid);
                btn.setAttribute('devicename', this.params.data.devicename);
            }
        }


        destroy() {
            this.eGui.removeEventListener('click', this.toggleHandler);
            this.eGui.removeEventListener('click', this.editDeviceHandler);
            this.eGui.removeEventListener('click', this.activateStatusHandler);
            this.eGui.removeEventListener('click', this.deactivateStatusHandler);
            this.eGui.removeEventListener('click', this.deleteDeviceHandler);
        }
    }

    // Each Column Definition results in one Column.
    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: '',
            field: 'deviceid',
            cellClass: ['actions-button-cell'],
            cellRenderer: DeviceManagementCellRenderer,
            minWidth: 24,
            maxWidth: 24,
            sortable: false,
            filter: false,
            resizable: false
        },
        {
            headerName: 'Device ID',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text', 'allow-text-select'],
            field: 'deviceid',
            maxWidth: 320,
            minWidth: 320,
            sortable: false,
            filter: false,
            resizable: false
        },
        {
            headerName: 'Device Name',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'devicename',
            maxWidth: 180,
            minWidth: 180,
            resizable: false
        },
        {
            headerName: 'Device URL',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'deviceurl'
        },
        {
            headerName: 'Vessel Name',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'vesselname',
            maxWidth: 180,
            minWidth: 180,
            resizable: false
        },
        {
            headerName: 'Vessel ID',
            cellClass: ['d-flex', 'text-wrap', 'ag-cell-custom-text'],
            field: 'vesselid',
            hide: true
        },
        {
            headerName: 'Status',
            field: 'status',
            maxWidth: 120,
            minWidth: 120,
            filter: false,
            cellRenderer: params => {
                var cell = '';
                if (params.data.status === 1) {
                    cell += 'Enabled';
                }
                else {
                    cell += 'Disabled';
                }

                return cell;
            },
            cellClass: params => {
                if (params.data.status === 1) {
                    return ['d-flex', 'text-wrap', 'col-green', 'ag-cell-custom-text'];
                }
                else {
                    return ['d-flex', 'text-wrap', 'ag-cell-custom-text'];
                }
            },
            resizable: false
        }
    ]);

    const sizeToFit = useCallback(() => {
        // Check if gridRef.current is not null before accessing the 'api' property
        if (gridRef.current) {
            gridRef.current.api.sizeColumnsToFit({
                defaultMinWidth: 100
            });
        }
    }, []);

    const handleResize = useCallback(() => {
        // Calculate the new container height on window resize
        const newContainerHeight = window.innerHeight - 350;
        setContainerHeight(newContainerHeight);

        // Detect mobile screen size (width <= 768px)
        const isMobile = window.innerWidth <= 768;
        setIsMobileScreen(isMobile);

        sizeToFit();
    }, []);

    // DefaultColDef sets props common to all Columns
    const defaultColDef = useMemo(() => ({
        sortable: true,
        filter: true,
        resizable: true,
        suppressMovable: true,
        // override all the defaults with font awesome
        icons: {
            // use font awesome for menu icons
            menu:'<i class="fa-solid fa-filter"></i>'
        }
    }));

    // Example of consuming Grid Event
    const cellClickedListener = useCallback(e => {
        const headerName = e.colDef.headerName;
        const colIndex = e.api
            .getColumns()
            ?.findIndex((col) => col.getColDef().headerName === headerName);

        //if not first cell, go inside to hide all
        if (colIndex > 0) {
            //hide all dropdown-menu with .show
            const dropdownMenus = document.querySelectorAll('.dropdown-menu.show');
            dropdownMenus.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('show');
            });

            //hide all dropdown-menu with .show
            const dropdownMenusMgmt = document.querySelectorAll('.dropdown-devicemgmt.col-rps-light');
            dropdownMenusMgmt.forEach((dropdownMenu) => {
                dropdownMenu.classList.remove('col-rps-light');
            });
        }

    }, []);

    useEffect(() => {
        // Add event listener for screen size change
        window.addEventListener('resize', handleResize);
        return () => {
            // Cleanup: remove event listener on component unmount
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (rowData !== undefined) {
            handleResize();
        }
    }, [rowData]); // Add rowData as a dependency so that this useEffect only runs when rowData changes

    // Example load data from server
    useEffect(() => {
        const _auth = JSON.parse(sessionStorage.getItem("auth"));
      
        if (!!_auth) {
            const role = _auth.role;

            //0:Admin, 1:Operator, 2:Project Manager, 3:Client
            if (role === 0 || role === 2) {
                getDevices();
            }
            else {
                navigate("/projects");
            }
        }
        else {
            getDevices();
        }

        deviceContext.SetRefreshFlag(false);
    }, [deviceContext.RefreshFlag]);

    const getDevices = async () => {
        const result = await DeviceServices.GetDevices();

        if (!!result) {
            setRowData(result.data);
        }
    };

    const handleDeactivate = async (e) => {
        const cancelButton = e.currentTarget;

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let deviceid = cancelButton.getAttribute('deviceid');

            const flag = await DeviceServices.SetDeviceStatus(deviceid, 2);

            if (!!flag) {
                const result = await DeviceServices.GetDevices();

                if (!!result) {
                    setRowData(result.data);
                }

                let devicename = cancelButton.getAttribute('devicename');
                handleError('Success', devicename + " device has been disabled.");
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Device has failed to disable due to system error. Please try again.');
            }

            hideDeactivate(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleActivate = async (e) => {
        const cancelButton = e.currentTarget;
        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            let deviceid = cancelButton.getAttribute('deviceid');

            const flag = await DeviceServices.SetDeviceStatus(deviceid, 1);

            if (!!flag) {
                const result = await DeviceServices.GetDevices();

                if (!!result) {
                    setRowData(result.data);
                }

                let devicename = cancelButton.getAttribute('devicename');
                handleError('Success', devicename + " device has been enabled.");
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Device has failed to enable due to system error. Please try again.');
            }

            hideActivate(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleDelete = async (e) => {
        const cancelButton = e.currentTarget;
        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');
            let deviceid = cancelButton.getAttribute('deviceid');
            const flag = await DeviceServices.DeleteDevice(deviceid);
            if (!!flag) {
                if (typeof flag.data.errormessage === 'undefined' || flag.data.errormessage === null || flag.data.errormessage === "") {
                    const result = await DeviceServices.GetDevices();
                    if (!!result) {
                        setRowData(result.data);
                    }
                    let devicename = cancelButton.getAttribute('devicename');
                    handleError('Success', devicename + " device has been deleted.");
                }
                else {
                    // Display error message for network errors
                    handleError('Error', `Device has failed to delete due to ${flag.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                // Display error message for network errors
                handleError('Error', 'Device has failed to delete due to system error. Please try again.');
            }
            hideDelete(cancelButton);
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
    };

    const handleCancelActivate = (e) => {
        const cancelButton = e.currentTarget;
        hideActivate(cancelButton);
    };

    const handleCancelDeactivate = (e) => {
        const cancelButton = e.currentTarget;
        hideDeactivate(cancelButton);
    };

    const handleCancelDelete = (e) => {
        const cancelButton = e.currentTarget;
        hideDelete(cancelButton);
    };
    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType,errorMessage);
    }

    const hideActivate = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-activate');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hideDeactivate = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-deactivate');

        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    const hideDelete = (btn) => {
        const dialogOverlay = btn.closest('.dialog-overlay-delete');
        if (dialogOverlay) {
            dialogOverlay.classList.add('hide');
        }
    };

    return (
        <>
       
            <div className="device-management-container" style={{ minHeight: '295px', height: `${!isMobileScreen ? `${containerHeight}px` : '100vh'}` }}>
                {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
                <div className="ag-theme-alpine device-management-with-context-menu" style={{ width: '100%', height: '100%' }}>

                    <AgGridReact
                        ref={gridRef} // Ref for accessing Grid's API

                        rowData={rowData} // Row Data for Rows
                        headerHeight={30}
                        rowHeight={30}
                        columnDefs={columnDefs} // Column Defs for Columns
                        defaultColDef={defaultColDef} // Default Column Properties

                        animateRows={true} // Optional - set to 'true' to have rows animate when sorted
                        rowSelection='single' // Options - allows click selection of rows
                        suppressMenuHide={true}
                        // Your grid options here....
                        suppressCellSelection={true}
                        onCellClicked={cellClickedListener} // Optional - registering for Grid Event
                    />
                </div>
                <div className="dialog-overlay dialog-overlay-activate hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button" onClick={handleCancelActivate}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Enable Device</p>
                        <p className="dialog-content">Are you sure wish to enable <span className="device-name-section"></span>?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-device-activate" onClick={handleActivate}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelActivate}>No</button>
                        </div>
                    </div>
                </div>
                <div className="dialog-overlay dialog-overlay-deactivate hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button font-big" onClick={handleCancelDeactivate}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Disable Device</p>
                        <p className="dialog-content">Are you sure wish to disable <span className="device-name-section"></span>?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-device-deactivate" onClick={handleDeactivate}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelDeactivate}>No</button>
                        </div>
                    </div>
                </div>
                <div className="dialog-overlay dialog-overlay-delete hide">
                    <div className="dialog-container">
                        <button className="dialog-close-button font-big" onClick={handleCancelDelete}>
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                        <p className="dialog-title col-rps-light mt-0 mb-0">Delete Device</p>
                        <p className="dialog-content">Are you sure wish to delete <span className="device-name-section"></span>?</p>
                        <div className="dialog-buttons float-right">
                            <button className="btn btn-dialog btn-primary btn-me btn-device-delete" onClick={handleDelete}>Yes</button>
                            <button className="btn btn-dialog btn-secondary" onClick={handleCancelDelete}>No</button>
                        </div>
                    </div>
                </div>
            <NewDevice />
            </div>
        </>
    );
}

export default DeviceManagement;
